import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Services } from 'app/servicios.service';
import { Propiedad } from 'app/models/propiedad-model';
import { ModalController, NavParams } from '@ionic/angular';
import { Imagen } from 'app/models/imagen-model';
import { NgbSlideEvent, NgbSlideEventSource, NgbCarousel } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-imagenes-modal',
  templateUrl: './imagenes-modal.component.html',
  styleUrls: ['./imagenes-modal.component.css']
})
export class ImagenesModalComponent implements OnInit {
  public id: string;
  public i: number;
  public propiedad: Propiedad;
  public imagenes: Array<Imagen>;
  @ViewChild('mycarousel', {static : true}) carousel: NgbCarousel;
  constructor(public location: Location,public modalCtrl: ModalController, public navParams: NavParams) { }

  ngOnInit(): void {
    this.imagenes = this.navParams.get('something');
    this.i = this.navParams.get('index');
    this.carousel.activeId = this.i.toString();
  }

  closeModal() { 
    this.modalCtrl.dismiss()
  }

  swipeRight() {
    if(this.i > 0){
      this.i = this.i-1;
      this.carousel.activeId = this.i.toString();
    }
  }

  swipeLeft() {
    if(this.i < this.imagenes.length){
      this.i = this.i+1;
      this.carousel.activeId = this.i.toString();
    }
  }

}
